import { toast } from "react-toastify";
import { backend } from "../../api";
import {
  FETCH_CUSTOMER_ARTICLES_FAIL,
  FETCH_CUSTOMER_ARTICLES_REQUEST,
  FETCH_CUSTOMER_ARTICLES_SUCCESS,
} from "../constants";

export const getUserArticleOrders = (id) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_CUSTOMER_ARTICLES_REQUEST });
    const { data } = await backend.get(`/articleOrder?user=${id}`);
    console.log(data);
    dispatch({ type: FETCH_CUSTOMER_ARTICLES_SUCCESS, payload: data.data });
  } catch (error) {
    toast.error(error.response ? error.response.data.message : error.message);

    dispatch({
      type: FETCH_CUSTOMER_ARTICLES_FAIL,
      payload: error.response ? error.response.data.message : error.message,
    });
  }
};
